/** Discriminador de tipo de cliente nas APIs (PF/PJ). */
export const CUSTOMER_TYPE = {
    PESSOA_JURIDICA: 'PESSOA_JURIDICA',
    PESSOA_FISICA: 'PESSOA_FISICA',
};

/** Placeholder quando o backend devolve nome nulo/vazio. */
export const UNIDENTIFIED_CUSTOMER_LABEL = 'Cliente não identificado';

/**
 * Normaliza valores vindos da API/navegação para o discriminador canônico.
 * @param {unknown} customerType
 * @returns {string|null}
 */
export function normalizeCustomerType(customerType) {
    if (customerType == null) return null;
    const raw = String(customerType).trim();
    if (!raw) return null;
    const upper = raw.toUpperCase().replace(/[\s-]+/g, '_');
    if (
        upper === CUSTOMER_TYPE.PESSOA_FISICA
        || upper === 'PHYSICAL_PERSON'
        || upper === 'PF'
        || upper === 'NATURAL_PERSON'
    ) {
        return CUSTOMER_TYPE.PESSOA_FISICA;
    }
    if (
        upper === CUSTOMER_TYPE.PESSOA_JURIDICA
        || upper === 'LEGAL_PERSON'
        || upper === 'PJ'
        || upper === 'COMPANY'
    ) {
        return CUSTOMER_TYPE.PESSOA_JURIDICA;
    }
    return null;
}

/**
 * @param {unknown} name
 * @returns {string}
 */
export function displayCustomerName(name) {
    const trimmed = name != null ? String(name).trim() : '';
    return trimmed || UNIDENTIFIED_CUSTOMER_LABEL;
}

/**
 * @param {unknown} customerType
 * @returns {boolean}
 */
export function isLegalPersonCustomer(customerType) {
    return normalizeCustomerType(customerType) === CUSTOMER_TYPE.PESSOA_JURIDICA;
}

/**
 * @param {unknown} customerType
 * @returns {boolean}
 */
export function isNaturalPersonCustomer(customerType) {
    return normalizeCustomerType(customerType) === CUSTOMER_TYPE.PESSOA_FISICA;
}
